import React, { useState, useEffect } from "react";
import { Button, Icon, Block } from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import LogoDark from "../../../images/logo.png";
import { invoiceData } from "./Invoice";
import { useLocation, useParams } from "react-router-dom";
import { getOrdersDetailsAPI } from "../../../api/order";
import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";
import { RUPEES_SYMBOL } from "../../../assets/constants";

const InvoicePrint = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState();
  const location = useLocation();
  let { invoiceId } = useParams();
  const logout = useLogout();
  useEffect(() => {
    setTimeout(() => {

      window.print();

    }, 1000);
  }, []);

  useEffect(() => {
    orderDetails();
  }, []);

  const orderDetails = () => {
    const body = {
      order_id: invoiceId,
    };
    setIsLoading(true);
    getOrdersDetailsAPI(body)
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setData(res.data.data);
          setIsLoading(false);
        } else if (res.data.status === false) {
          setIsLoading(false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <body className="bg-white">
      <Head title="Invoice Print"></Head>
      {isLoading ? null : (
        <Content>
          <Block>
            <div className="invoice invoice-print">
              <div className="invoice-action">
                <Button
                  size="lg"
                  color="primary"
                  outline
                  className="btn-icon btn-white btn-dim"
                  onClick={() => window.print()}
                >
                  <Icon name="printer-fill"></Icon>
                </Button>
              </div>
              <div className="invoice-wrap">
                <div className="invoice-brand text-center">
                  <img src={LogoDark} alt="" />
                </div>
                <div className="invoice-head">
                  <div className="row">
                    <div className="col-6">
                      <div className="invoice-contact">
                        <span className="overline-title">Shipping To</span>
                        <div className="invoice-contact-info">
                          <h4 className="title">{data?.address?.full_name}</h4>
                          <ul className="list-plain">
                            <li>
                              <Icon name="map-pin-fill"></Icon>
                              <span>
                                {data?.address?.address}
                                <br />
                                {data?.address?.city}, {data?.address?.state}, {data?.address?.country}{" "}
                                {data?.address?.postal_code}
                              </span>
                            </li>
                            <li>
                              <Icon name="call-fill"></Icon>
                              <span>{data?.address?.mobile}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      {/* BILLING ADDRESS */}
                      <div className="invoice-contact">
                        <span className="overline-title">Billing To</span>

                        {data?.is_billing_same_as_shipping ? (
                          <div className="invoice-contact-info">
                            <h6 className="text-muted">Same as Shipping Address</h6>
                          </div>
                        ) : (
                          <div className="invoice-contact-info">
                            <h4 className="title">{data?.billing_Address?.full_name}</h4>
                            <ul className="list-plain">
                              <li>
                                <Icon name="map-pin-fill" />
                                <span>
                                  {data?.billing_Address?.address}
                                  <br />
                                  {data?.billing_Address?.city},{" "}
                                  {data?.billing_Address?.state},{" "}
                                  {data?.billing_Address?.country}{" "}
                                  {data?.billing_Address?.postal_code}
                                </span>
                              </li>
                              <li>
                                <Icon name="call-fill" />
                                <span>{data?.billing_Address?.mobile}</span>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="invoice-contact">
                    <span className="overline-title">Invoice To</span>
                    <div className="invoice-contact-info">
                      <h4 className="title">{data?.address?.full_name}</h4>
                      <ul className="list-plain">
                        <li>
                          <Icon name="map-pin-fill"></Icon>
                          <span>
                            {data?.address?.address}
                            <br />
                            {data?.address?.city}, {data?.address?.state}, {data?.address?.country}{" "}
                            {data?.address?.postal_code}
                          </span>
                        </li>
                        <li>
                          <Icon name="call-fill"></Icon>
                          <span>{data?.address?.mobile}</span>
                        </li>
                      </ul>
                    </div>
                  </div> */}
                  <div className="invoice-desc">
                    <h3 className="title">Invoice</h3>
                    <ul className="list-plain">
                      <li className="invoice-id">
                        <span>Invoice ID</span>:<span>{data?.invoice_no}</span>
                      </li>
                      <li className="invoice-date">
                        <span>Date</span>:<span>{data?.date?.split(",")[0]}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="invoice-bills">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="w-150px">Item</th>
                          {/* <th className="w-60">Description</th> */}
                          <th></th>
                          <th>Price</th>
                          <th>Qty</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.items?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.product_name}</td>
                            <td></td>
                            {/* <td>Dashlite - Conceptual App Dashboard - Regular License</td> */}
                            <td>
                              {RUPEES_SYMBOL}
                              {item?.unit_price}
                            </td>
                            <td>{item?.quantity}</td>
                            <td>
                              {RUPEES_SYMBOL}
                              {item?.total}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Subtotal</td>
                          <td>
                            {RUPEES_SYMBOL}
                            {data?.subtotal}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Shipping fee</td>
                          <td>{data?.shipping_cost}</td>
                        </tr>
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">GST</td>
                          <td>{data?.tax}</td>
                        </tr>
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Discount</td>
                          <td>{data?.discount}</td>
                        </tr>
                        {data?.online_discount &&
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="2">Online Payment Discount (2%)</td>
                            <td>{data?.online_discount || 0}</td>
                          </tr>
                        }
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Coupon</td>
                          <td>{data?.coupon_name || "N/A"}</td>
                        </tr>
                        <tr>
                          <td colSpan="2"></td>
                          <td colSpan="2">Grand Total</td>
                          <td>
                            {RUPEES_SYMBOL}
                            {data.total_amount}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    <div className="nk-notes ff-italic fs-12px text-soft">
                      Invoice was created on a computer and is valid without the signature and seal.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Block>
        </Content>
      )}
    </body>
  );
};

export default InvoicePrint;
